export class FontSizeTool {
  static get isInline() {
    return true // This is an inline tool
  }

  constructor({ api }) {
    this.api = api
    this.button = null
    this._state = false

    this.tag = 'SPAN' // Use <span> for styling
    this.classPrefix = 'font-size--' // Class prefix for font size
    this.defaultClass = `${this.classPrefix}normal` // Default font size class
  }

  get state() {
    return this._state
  }

  set state(state) {
    this._state = state
    this.button.classList.toggle(this.api.styles.inlineToolButtonActive, state)
  }

  render() {
    this.button = document.createElement('button')
    this.button.type = 'button'
    this.button.innerHTML = 'A<span style="font-size: smaller;">a</span>' // Button icon
    this.button.classList.add(this.api.styles.inlineToolButton)
    return this.button
  }

  surround(range) {
    const blockType = this.api.blocks.getBlockByIndex(
      this.api.blocks.getCurrentBlockIndex()
    ).name

    // Ensure this tool only works on paragraph blocks
    if (blockType !== 'paragraph') {
      console.warn('FontSizeTool can only be used with paragraph blocks.')
      return
    }

    if (this.state) {
      this.unwrap(range) // Remove font size if already applied
    } else {
      this.wrap(range) // Apply font size
    }
  }

  wrap(range) {
    const selectedText = range.extractContents()
    const span = document.createElement(this.tag)

    span.classList.add(this.defaultClass) // Add default font size class
    span.appendChild(selectedText)
    range.insertNode(span)

    this.api.selection.expandToTag(span)
  }

  unwrap(range) {
    const span = this.api.selection.findParentTag(this.tag)
    if (!span) return

    // Check if the span has any font-size--* class
    const fontSizeClass = Array.from(span.classList).find((cls) =>
      cls.startsWith(this.classPrefix)
    )

    if (!fontSizeClass) return

    const text = range.extractContents()
    span.remove()
    range.insertNode(text)
  }

  checkState(selection) {
    const blockType = this.api.blocks.getBlockByIndex(
      this.api.blocks.getCurrentBlockIndex()
    ).name

    // Update state only for paragraph blocks
    if (blockType !== 'paragraph') {
      this.state = false
      this.hideActions()
      return
    }

    const span = this.api.selection.findParentTag(this.tag)
    this.state = !!span

    if (this.state) {
      this.showActions(span)
    } else {
      this.hideActions()
    }
  }

  renderActions() {
    this.fontSizePicker = document.createElement('select')
    this.fontSizePicker.hidden = true

    const sizes = ['normal', 'large']
    sizes.forEach((size) => {
      const option = document.createElement('option')
      option.value = size
      option.textContent = size
      this.fontSizePicker.appendChild(option)
    })

    return this.fontSizePicker
  }

  showActions(span) {
    const classes = Array.from(span.classList)
    const currentClass =
      classes.find((cls) => cls.startsWith(this.classPrefix)) ||
      this.defaultClass
    const currentSize = currentClass.replace(this.classPrefix, '')

    this.fontSizePicker.value = currentSize
    this.fontSizePicker.hidden = false

    this.fontSizePicker.onchange = () => {
      // Remove any existing font-size class
      classes.forEach((cls) => {
        if (cls.startsWith(this.classPrefix)) {
          span.classList.remove(cls)
        }
      })

      // Add the new font-size class
      const newClass = `${this.classPrefix}${this.fontSizePicker.value}`
      span.classList.add(newClass)
    }
  }

  hideActions() {
    this.fontSizePicker.onchange = null
    this.fontSizePicker.hidden = true
  }

  static get sanitize() {
    return {
      span: {
        class: true,
      },
    }
  }
}
